import ADEPTA_SORORITAS from "./ADEPTA_SORORITAS";
import ADEPTUS_MECHANICUS from "./ADEPTUS_MECHANICUS";
import ASTRA_MILITARUM from "./ASTRA_MILITARUM";
import BLACK_TEMPLARS from "./BLACK_TEMPLARS";
import CHAOS_KNIGHTS from "./CHAOS_KNIGHTS";
import DRUKHARI from "./DRUKHARI";

const data = {
  ADEPTA_SORORITAS: ADEPTA_SORORITAS,
  ADEPTUS_MECHANICUS: ADEPTUS_MECHANICUS,
  ASTRA_MILITARUM: ASTRA_MILITARUM,
  BLACK_TEMPLARS: BLACK_TEMPLARS,
  CHAOS_KNIGHTS: CHAOS_KNIGHTS,
  DRUKHARI: DRUKHARI,
};

export default data;
